function FBAuth () {
  var self = this

  self.openGetCodePage = function (fbClientID, redirectUri, jwtToken, scope) {
    return new Promise((resolve, reject) => {
      const version = 'v9.0'
      let scopeURL = scope ? '&scope=' + scope : ''
      let url = `https://www.facebook.com/${version}/dialog/oauth?client_id=${fbClientID}&redirect_uri=${redirectUri}&state=${jwtToken}${scopeURL}`

      window.handleFBLoginResult = (eventData, error) => {
        console.log(`handleFBLoginResult`, eventData, error)
        if (error) {
          reject(error)
        } else {
          resolve(eventData)
        }
      }
      window.open(url)
    })
  }
}

window.addEventListener('message', (event) => {
  let message = event.data.message
  let error = event.data.error
  if (message === 'fb-oauth-event' && typeof window.handleFBLoginResult === 'function') {
    window.handleFBLoginResult(event.data, error)
  }
})
export default new FBAuth()
